import { useEffect } from 'react';

export function requestedPanelId(search: string, targets: Readonly<Record<string, string>>): string | null {
  const panels = new URLSearchParams(search).getAll('panel');
  return panels.length === 1 && Object.prototype.hasOwnProperty.call(targets, panels[0]) ? targets[panels[0]] : null;
}

/** Closed selectors reveal existing controls; a link never performs their action. */
export function useDisclosureLink(search: string, targets: Readonly<Record<string, string>>) {
  const id = requestedPanelId(search, targets);
  useEffect(() => {
    if (!id) return;
    let revealFrame = 0;
    const frame = requestAnimationFrame(() => {
      revealFrame = requestAnimationFrame(() => {
        const disclosure = document.getElementById(id);
        if (!(disclosure instanceof HTMLDetailsElement)) return;
        disclosure.open = true;
        disclosure.querySelector('summary')?.focus({ preventScroll: true });
        disclosure.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    });
    // The explicit panel takes priority over list-reader focus on mobile.
    return () => { cancelAnimationFrame(frame); cancelAnimationFrame(revealFrame); };
  }, [id, search]);
}
